import Reveal from "@/components/Reveal";
import { CheckCircle2, Wrench, XCircle, MoveUpRight, Sparkles } from "lucide-react";

const states = [
  { icon: CheckCircle2, label: "Están funcionando correctamente", color: "text-neoncyan" },
  { icon: Wrench, label: "Necesitan ajustes", color: "text-magenta" },
  { icon: XCircle, label: "Faltan por completo", color: "text-violet" },
];

const Deliverable = () => (
  <section className="relative overflow-hidden border-t border-white/10 py-28 md:py-40" data-testid="deliverable-section">
    <img
      src="https://images.unsplash.com/photo-1646784208071-7f35325e10cb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwzfHxhYnN0cmFjdCUyMGxpZ2h0JTIwdHJhaWxzJTIwbWFnZW50YSUyMGN5YW58ZW58MHx8fHwxNzg1OTY0MTk5fDA&ixlib=rb-4.1.0&q=85"
      alt=""
      className="absolute inset-0 h-full w-full object-cover opacity-25"
    />
    <div className="absolute inset-0 bg-gradient-to-r from-plum via-plum/80 to-plum/40" />

    <div className="relative mx-auto max-w-7xl px-6 md:px-12">
      <div className="grid gap-16 md:grid-cols-12">
        <div className="md:col-span-7">
          <Reveal>
            <p className="mb-6 text-xs font-medium uppercase tracking-[0.35em] text-neoncyan">
              Entregable final
            </p>
            <h2 className="font-display text-4xl font-black uppercase leading-[0.95] tracking-tighter md:text-6xl">
              El Mapa <span className="text-magenta">CEREBRO</span> de tu marca
            </h2>
            <p className="mt-8 max-w-xl text-sm leading-relaxed text-lilac/90 md:text-base">
              A lo largo de las sesiones vas a completar un diagnóstico de tu marca para
              identificar cuáles de las siete señales:
            </p>
          </Reveal>
          <div className="mt-10 flex flex-col gap-4">
            {states.map((s, i) => (
              <Reveal key={s.label} delay={i * 0.1}>
                <div className="glass flex items-center gap-4 px-6 py-4" data-testid={`deliverable-state-${i + 1}`}>
                  <s.icon className={`h-5 w-5 shrink-0 ${s.color}`} />
                  <p className="text-sm uppercase tracking-[0.15em] text-rosewhite/90 md:text-base">
                    {s.label}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
        <div className="flex flex-col justify-end md:col-span-5">
          <Reveal delay={0.2}>
            <div className="border border-magenta/40 bg-black/40 p-8 backdrop-blur-xl md:p-10">
              <MoveUpRight className="mb-6 h-8 w-8 text-magenta" />
              <p className="font-display text-2xl font-extrabold uppercase leading-tight tracking-tight md:text-3xl">
                Tres movimientos concretos y prioritarios
              </p>
              <p className="mt-4 text-sm leading-relaxed text-lilac/90">
                Al finalizar, vas a definir las tres acciones para mejorar la manera en que
                tu marca es vista, percibida, evaluada y recordada por sus consumidores.
              </p>
              <div className="mt-8 flex items-start gap-3 border-t border-white/10 pt-6">
                <Sparkles className="mt-0.5 h-4 w-4 shrink-0 text-neoncyan" />
                <p className="text-xs leading-relaxed text-lilac/80">
                  Incluye acceso a una herramienta interactiva con inteligencia artificial que
                  usa los resultados de tu diagnóstico para darte recomendaciones personalizadas.
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

export default Deliverable;
